import { useMutation } from '@tanstack/react-query';

import OffersService from '~/services/OffersService';

interface GeneratedBedConfiguration {
  bed_type?: string;
  quantity?: number;
}

export interface GeneratedBeddingConfigurationResponse {
  result?: {
    bed_grouping?: Array<Array<GeneratedBedConfiguration>>;
  };
}

export interface BulkGeneratedBeddingConfigurationItem {
  deal_offer_id: string;
  message?: string;
  result?: {
    bed_grouping?: Array<Array<GeneratedBedConfiguration>>;
    success?: boolean;
  };
  status: number;
}

export interface BulkGeneratedBeddingConfigurationResponse {
  result?: Array<BulkGeneratedBeddingConfigurationItem>;
}

export function useGenerateBeddingConfiguration() {
  return useMutation({
    mutationFn: (dealId: string) =>
      OffersService.generateBeddingConfiguration(dealId) as Promise<GeneratedBeddingConfigurationResponse>,
  });
}

export function useGenerateBulkBeddingConfigurations() {
  return useMutation({
    mutationFn: (dealIds: Array<string>) =>
      OffersService.generateBulkBeddingConfigurations(dealIds) as Promise<BulkGeneratedBeddingConfigurationResponse>,
  });
}
